module.exports = __webpack_public_path__ + "img/company-user.2edc64a9.svg";